angular.module('ihestiaMenuTopMenu')
  .controller('ihestiaMenuSaleLifeCtrl', ['$scope', 'ihestiaConfigHelper', '$window', 'ihestiaAgHelper', '$state', 'apkSvc',
    function($scope, ihestiaConfigHelper, $window, ihestiaAgHelper, $state, apkSvc){

      $scope.lifePermissions = {
        sirius: ihestiaAgHelper.canAccessSyriusz(),
        lifeSalePath: ihestiaAgHelper.canAccessLifeSalePathApp()
      };

      $scope.init = function() {
      };

      /**
       * Idziemy do zewnętrznego urla
       * @param  {string} urlCode [description]
       */
      $scope.gotoExternal = function(urlCode, available) {
        if(angular.isUndefined(available) || available){
          $window.open( ihestiaConfigHelper.getUrl(urlCode));
        }
      };

      $scope.gotoExternalAPK = function(urlCode, available) {
        if(angular.isUndefined(available) || available){
          $window.open( ihestiaConfigHelper.getUrl(urlCode) + apkSvc.getAPKPostfix(null));
        }
      };

      $scope.gotoSirius = function() {
        if ($scope.lifePermissions.sirius) {
          $scope.gotoExternal('SYRIUSZ_URL');
          $state.go('main.mainPage');
        }
      };

      $scope.gotoLifeSalePath = function() {
        if($scope.lifePermissions.lifeSalePath) {
          apkSvc.showModalWithRedirectCallback(function(){
            $scope.gotoExternalAPK('E4_URL');
          });
        }
      };
    }
  ]);
